module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/define-properties.js
// module id = 434
// module chunks = 34